const MAIL_REPLY_GREEN = '#1a7d3e';
const MAIL_REPLY_GREEN_LIGHT = '#f0f9f2';
const MAIL_REPLY_GREEN_RING = '0 0 0 3px rgba(26, 125, 62, 0.12)';

/** UI-only react-select theme (primary green) for mail compose / reply dropdowns */
export const mailReplySelectStyles = {
    control: (base, state) => ({
        ...base,
        minHeight: 38,
        borderRadius: 8,
        borderColor: state.isFocused ? MAIL_REPLY_GREEN : '#e0e8e3',
        boxShadow: state.isFocused ? MAIL_REPLY_GREEN_RING : 'none',
        '&:hover': {
            borderColor: state.isFocused ? MAIL_REPLY_GREEN : '#c6e8ce',
        },
    }),
    option: (base, { isFocused, isSelected, data }) => ({
        ...base,
        backgroundColor: isSelected
            ? MAIL_REPLY_GREEN
            : isFocused
                ? MAIL_REPLY_GREEN_LIGHT
                : '#ffffff',
        color: isSelected
            ? '#ffffff'
            : isFocused
                ? MAIL_REPLY_GREEN
                : !data?.value
                    ? '#4b5563'
                    : '#374151',
        cursor: 'pointer',
    }),
    menu: (base) => ({
        ...base,
        zIndex: 9999,
        scrollbarWidth: 'none',
        overflowY: 'auto',
        borderRadius: 8,
        border: '1px solid #e9ecef',
        boxShadow: '0 4px 16px rgba(26, 125, 62, 0.1)',
    }),
    menuList: (base) => ({
        ...base,
        padding: 4,
    }),
    dropdownIndicator: (base, state) => ({
        ...base,
        color: state.isFocused ? MAIL_REPLY_GREEN : '#9ca3af',
        '&:hover': { color: MAIL_REPLY_GREEN },
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    singleValue: (base) => ({
        ...base,
        color: '#374151',
    }),
    placeholder: (base) => ({
        ...base,
        color: '#4b5563',
    }),
};
